const state = {
  filmData: {},
  filmActive: false,
  fullScreenFilmActive: false,
};

const mutations = {
  CHANGE_FILM_CONTENT(state, filmObj) {
    state.filmData = filmObj;
  },
  CHANGE_FILM_ACTIVE(state, filmActive) {
    state.filmActive = filmActive;
  },
  CHANGE_FULLSCREEN_FILM_ACTIVE(state, fullScreenFilmActive) {
    state.fullScreenFilmActive = fullScreenFilmActive;
  },
};

const actions = {
  someAsyncTask({ commit }) {
    // do something async
    commit('TEST');
  },
};

const getters = {
  filmData: (state) => {
    return state.filmData;
  },
  filmActive: (state) => {
    return state.filmActive;
  },
  fullScreenFilmActive: (state) => {
    return state.fullScreenFilmActive;
  },
};
export default {
  state,
  mutations,
  actions,
  getters,
};
